import React, { useEffect, useState } from 'react';
import TodoList from '../todo/TodoList';
import TaskList from '../task/TaskList';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';
import { getTodos } from '../apiCallsHelper/todoapicalls';
import addTodoImg from "../images/add-todo-img.png";
import todosImg from "../images/todos-img.png";



const TodoTaskLists = ({ isSubmitted, setIsSubmitted, isTodos, setIsTodos, isTasksAvailable, setIsTasksAvailable }) => {

    const [todos, setTodos] = useState([]);
    const { user, token } = isAuthenticated();
    const [findTodo, setFindTodo] = useState(null);
    const [isTaskAdded, setIsTaskAdded] = useState(false);
    const [activeTodo, setActiveTodo] = useState(null);
    const [isPrevClicked, setIsPrevClicked] = useState(false);
    const [isTodoEdited, setIsTodoEdited] = useState(false);



    const fetchTodos = () => {
        getTodos(user._id, token)
            .then(data => {
                if (data.error) {
                    // console.log("data error: ", data.error)
                }
                else {
                    setTodos(data.todos)
                    setIsSubmitted(!setIsSubmitted)

                    if (data.todos.length === 0) {
                        setIsTodos(false);
                        setActiveTodo(false);
                    }

                    setActiveTodo(false);
                }
            })
    }






    useEffect(() => {
        fetchTodos();
    }, [isTodos, isSubmitted]);





    return (

        <>
            {isTodos ? (
                <div className='  flex  flex-col     xs:flex-col   sm:flex-col    md:flex md:flex-col  smLaptop:flex-row  lg:flex lg:flex-row  lg:h-[900px]  '>
                    <div className=' w-full    md:w-full  smLaptop:w-[635px]   lg:w-3/4   xl:w-3/1    '>
                        <TodoList todos={todos} setTodos={setTodos} setIsTodos={setIsTodos} findTodo={findTodo} setFindTodo={setFindTodo} isTaskAdded={isTaskAdded} setIsTaskAdded={setIsTaskAdded} activeTodo={activeTodo} setActiveTodo={setActiveTodo} setIsTodoEdited={setIsTodoEdited} isTodoEdited={isTodoEdited} />
                    </div>
                    <div className='  w-full xs:w-full  mobSm:full sm:w-full mobLg:w-full   md:w-full  smLaptop:w-1/2 smLaptop:border-l smLaptop:border-gray-300     lg:w-1/4 lg:border-l lg:border-gray-300  xl:w-1/3 xl:border-l xl:border-gray-300'>
                        <TaskList todos={todos} findTodo={findTodo} setFindTodo={setFindTodo} isTaskAdded={isTaskAdded} setIsTaskAdded={setIsTaskAdded} activeTodo={activeTodo} isTasksAvailable={isTasksAvailable} setIsTasksAvailable={setIsTasksAvailable} isTodoEdited={isTodoEdited} />
                    </div>
                </div>
            ) : (
                <div className=' w-full  xl:w-full  flex items-center justify-center h-[205px] text-[#536491] text-xl font-bold '>
                    <div className='flex flex-col items-center  md:hidden'>
                        <div className=''>
                            <div className='    md:hidden '>Please add Todo!</div>
                        </div>
                        <div className='flex  mt-4'>
                            <img src={addTodoImg} alt="add todo" className='h-[110px] w-[110px]  xs:h-[150px] xs:w-[200px] sm:h-[200px] sm:w-[300px]  ' />
                            <img src={todosImg} alt="todo list" className=' w-[110px] h-[110px]  xs:w-[140px] xs:h-[140px]   sm:w-[150px] sm:h-[150px]   ' />
                        </div>
                    </div>
                    <img src={addTodoImg} alt="add todo" className=' hidden  md:flex md:h-[220px] md:w-[300px] md:ml-[20px]  smLaptop:ml-[20px] smLaptop:h-[220px] smLaptop:w-[300px]   lg:ml-[20px] lg:h-[220px] lg::w-[300px]  xl:ml-[20px] xl:h-[220px] xl:w-[300px]' />
                    <img src={todosImg} alt="todo list" className=' hidden   md:flex md:w-[200px] md:h-[200px]    smLaptop:w-[200px] smLaptop:h-[180px] smLaptop:ml-[10px]   lg:w-[220px] lg:h-[190px] lg:ml-[20px]  xl:w-[240px] xl:h-[200px] xl:ml-[20px]' />
                    <div className='  hidden  md:block md:ml-10 smLaptop:ml-[140px] smLaptop:ml-8 lg:ml-[140px] xl:ml-[140px]'>Please add Todo!</div>
                </div>
            )
            }
        </>
    )
}



export default TodoTaskLists;